module.exports = __webpack_public_path__ + "53b2b8a3914ecf660096a4168825e5f2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/bird.svg
// module id = 79
// module chunks = 0